export default __webpack_public_path__ + "static/media/linicon.bb214538.svg";